<template lang="pug">
    v-card.elevation-25(v-if="user")
        .d-flex.justify-space-between.align-start
            v-card-title.pb-0 {{user.Attributes.given_name}} {{user.Attributes.family_name}}
            v-switch(:input-value="user.Enabled" hide-details dense inset @change="activateDeactivate(user.Enabled)") 
        v-card-subtitle.py-1 {{user.Attributes.email}}
        code.ml-3.pt-1 {{user.Username}}
        v-card-actions
            //- v-chip.mr-2(small) {{user.UserStatus}}
            v-tooltip(bottom='')
                template(v-slot:activator='{ on, attrs }')
                    v-icon.mr-2(:color='formatUserStatus(user.UserStatus).color' dark='' v-bind='attrs' v-on='on')
                        | {{formatUserStatus(user.UserStatus).icon}}
                span {{formatUserStatus(user.UserStatus).text}}

            v-chip(small :color='user.Attributes["custom:tenantRole"] == "TENANT_USER" ? "primary" : "accent"') {{user.Attributes["custom:tenantRole"] == "TENANT_USER" ? "User" : "Admin"}}
            v-spacer
            CreateEditUserDialog(:edit="true" :user="user")
            v-btn(icon exact small color="red" @click="deleteUser(user.Username)")
                v-icon delete
</template>

<script>
import date from "@/utils/date";
import CreateEditUserDialog from "@/components/admin/CreateEditUserDialog.vue";
export default {
  components: {
    CreateEditUserDialog,
  },
  props: ["user"],
  data() {
    return {
      switchEnabled: true,
    };
  },
  methods: {
    ...date,
    formatUserStatus(status) {
      switch (status) {
        case "CONFIRMED":
          return {
            icon: "verified_user",
            color: "green",
            text: "User has been confirmed.",
          };
        case "UNCONFIRMED":
          return {
            icon: "verified_user",
            color: "warning",
            text: "User has been created but not confirmed.",
          };
        case "ARCHIVED":
          return {
            icon: "archive",
            color: "grey",
            text: "User is no longer active.",
          };
        case "COMPROMISED":
          return {
            icon: "report",
            color: "red",
            text: "User is disabled due to a potential security threat.",
          };
        case "RESET_REQUIRED":
          return {
            icon: "pin",
            color: "warning",
            text: "User is confirmed, but the user must request a code and reset his or her password before he or she can sign in.",
          };
        case "FORCE_CHANGE_PASSWORD":
          return {
            icon: "password",
            color: "warning",
            text: "The user is confirmed and the user can sign in using a temporary password, but on first sign-in, the user must change his or her password to a new value before doing anything else.",
          };

        default:
          return {
            icon: "error",
            color: "red",
            text: "User status is not known.",
          };
      }
    },
    async activateDeactivate(status) {
      this.switchEnabled = false;
      await this.$store.dispatch("superAdmin/SET_USER_STATUS", {
        status: !status,
        username: this.user.Username,
      });
      this.switchEnabled = true;
    },
    deleteUser(username) {
      const deleteUserAlert = confirm(
        `Are you sure you want to delete user with id: ${username}`
      );
      if (deleteUserAlert) {
        this.$store.dispatch("superAdmin/DELETE_USER", { username });
      }
    },
  },
};
</script>

<style lang="sass" scoped>
@import '@/assets/style/main'
</style>
